var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.756836,
    width: 52.2523,
    height: 52.2523,
    rx: 26.1261,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7831 34.126C24.6916 35.1051 26.8871 35.3703 28.9739 34.8738C31.0607 34.3773 32.9016 33.1519 34.1648 31.4182C35.428 29.6846 36.0305 27.5567 35.8636 25.4182C35.6968 23.2796 34.7716 21.271 33.2549 19.7542C31.7381 18.2374 29.7294 17.3123 27.5909 17.1454C25.4523 16.9786 23.3245 17.5811 21.5909 18.8443C19.8572 20.1075 18.6317 21.9483 18.1353 24.0351C17.6388 26.1219 17.904 28.3174 18.8831 30.226L16.8831 36.126L22.7831 34.126Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6463 28.0295C27.7324 28.069 27.8293 28.078 27.9212 28.0551C28.0131 28.0321 28.0944 27.9786 28.1517 27.9032L28.2996 27.7095C28.3773 27.606 28.4779 27.522 28.5936 27.4641C28.7093 27.4063 28.8369 27.3761 28.9663 27.3761H30.2163C30.4373 27.3761 30.6493 27.4639 30.8056 27.6202C30.9618 27.7765 31.0496 27.9885 31.0496 28.2095V29.4595C31.0496 29.6805 30.9618 29.8924 30.8056 30.0487C30.6493 30.205 30.4373 30.2928 30.2163 30.2928C28.2272 30.2928 26.3195 29.5026 24.913 28.0961C23.5065 26.6896 22.7163 24.7819 22.7163 22.7928C22.7163 22.5718 22.8041 22.3598 22.9604 22.2036C23.1167 22.0473 23.3286 21.9595 23.5496 21.9595H24.7996C25.0207 21.9595 25.2326 22.0473 25.3889 22.2036C25.5452 22.3598 25.633 22.5718 25.633 22.7928V24.0428C25.633 24.1722 25.6029 24.2998 25.545 24.4155C25.4871 24.5312 25.4031 24.6319 25.2996 24.7095L25.1046 24.8557C25.0281 24.9141 24.9742 24.9972 24.9521 25.0909C24.9299 25.1845 24.9408 25.283 24.983 25.3695C25.5524 26.5261 26.489 27.4615 27.6463 28.0295Z",
    fill: "#0071DA",
    stroke: "#0071DA",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(21.8831 21.126)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWa);
export default __webpack_public_path__ + "static/media/wa.aaff1425123c83289ce015ded2e7df3a.svg";
export { ForwardRef as ReactComponent };